import { cn } from "@/lib/utils";

interface KbdProps extends React.ComponentProps<"kbd"> {
  pressed?: boolean;
  uppercase?: boolean;
  variant?: "default" | "raised";
}

export function Kbd({
  className,
  pressed = false,
  uppercase = true,
  variant = "default",
  ...props
}: KbdProps) {
  return (
    <kbd
      className={cn(
        "inline-flex h-5 min-w-5 flex-none select-none items-center justify-center rounded-md font-sans text-[13px] text-gray-1000 will-change-transform",
        "transition-[background-color,border-color,color,scale] duration-100 ease-out motion-reduce:transition-none",
        uppercase ? "uppercase" : "normal-case",
        variant === "default" && "border border-gray-400 bg-gray-200",
        variant === "raised" &&
          "border border-gray-400 bg-preview-bg font-[450] text-gray-1100 text-xs",
        pressed && "scale-97 text-gray-1200",
        pressed && variant === "default" && "border-gray-500 bg-gray-300",
        pressed && variant === "raised" && "border-gray-500 bg-gray-100",
        className
      )}
      {...props}
    />
  );
}
